import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  open: {
    id: 'open',
    defaultMessage: 'Open',
    description: 'A note displayed when a restaurant is open.',
  },
  closed: {
    id: 'closed',
    defaultMessage: 'Closed',
    description: 'A note displayed when a restaurant is closed.',
  },
  until: {
    id: 'until',
    defaultMessage: 'until',
    description:
      'Will be followed in the UI by a closing time to let the user know what time the restaurant is open until.',
  },
  getDirections: {
    id: 'getDirections',
    defaultMessage: 'Get Directions',
    description: 'Text for CTA that takes user to directions to a store.',
  },
  dineIn: {
    id: 'dineIn',
    defaultMessage: 'Dine in',
    description: 'The name of a service mode - eating at the restaurant.',
  },
  takeOut: {
    id: 'takeOut',
    defaultMessage: 'Take Out',
    description: 'The name of a service mode - picking food up from the restaurant.',
  },
  driveThru: {
    id: 'driveThru',
    defaultMessage: 'Drive Thru',
    description: "The name of a service mode - picking up food at the restaurant's drive-thru.",
  },
  curbside: {
    id: 'curbside',
    defaultMessage: 'Curbside',
    description: 'The name of a service mode - picking up food outside the restaurant.',
  },
  storeInfoAssistive: {
    id: 'storeInfoAssistive',
    defaultMessage: 'See information for this store',
    description: 'The accessibility label for a CTA that takes the user to store information.',
  },
  storeInfo: {
    id: 'storeInfo',
    defaultMessage: 'Info & Photo',
    description: 'Button text for a CTA that takes the user to store information.',
  },
  changeLanguage: {
    id: 'changeLanguage',
    defaultMessage: 'Select Language and Region',
    description:
      'The heading of a modal that allows users to change their selected language and region.',
  },
  changeRegionOnOrder: {
    id: 'changeRegionOnOrder',
    defaultMessage:
      'We need a little more information, please confirm your region to continue ordering',
    description:
      'A note displayed to the user on an order attempt - asks them to confirm their selected region.',
  },
  changeRegionConfirmation: {
    id: 'changeRegionConfirmation',
    defaultMessage: 'Please confirm your region to continue.',
    description: 'A note to the user that they need to confirm their selected region.',
  },
  changeRegionDisclaimer: {
    id: 'changeRegionDisclaimer',
    defaultMessage: 'Please note you will need to select your restaurant again.',
    description:
      'A note to the user that changing their region will erase their restaurant selection.',
  },
  orderHere: {
    id: 'orderHere',
    defaultMessage: 'Order here',
    description:
      'The button text for a CTA that allows the user to start an online order at a specific restaurant.',
  },
  select: {
    id: 'select',
    defaultMessage: 'Select',
    description:
      'The button text for a CTA that allows the user to select a restaurant without starting an order.',
  },
  moreInfo: {
    id: 'moreInfo',
    defaultMessage: 'More info',
    description:
      'The button text for a CTA that allows the user to see more info about a restaurant.',
  },
  orderAtThisStore: {
    id: 'orderAtThisStore',
    defaultMessage: 'Order at this store',
    description:
      'The accessibility label for a CTA that allows the user to start an online order at a specific restaurant.',
  },
  selectRestaurant: {
    id: 'selectRestaurant',
    defaultMessage: 'Select Restaurant',
    description:
      'The accessibility label for a CTA that allows the user to select a restaurant without starting an order.',
  },
  onlineSoon: {
    id: 'onlineSoon',
    defaultMessage: 'Online Soon',
    description:
      'A note to let the user know that online ordering will soon be available for a specific restaurant, but is not currently available.',
  },
});
